import React from 'react';
import BookList from './books-details/BookList';
import Form from './books-details/Form';

const Books = () => (
  <main>
    <BookList />
    <Form />
  </main>
);

export default Books;
